export default "__VITE_ASSET__DjkJCepj__";